import AuthenticationRepository from './AuthenticationRepository.js'

export default class ConfigRepository extends AuthenticationRepository {
  constructor({config}) {
    super()

    this._config = config
  }

  getUrl = () => {
    return new Promise((resolve, reject) => {
      try {
        resolve(this._config.get('page').USER_PROFILE_PATTERN)
      } catch (error) {
        reject(error)
      }
    })
  }
}
